export function LiveBadge({ label = "Live" }: { label?: string }) {
  return (
    <span className="ui-live-badge">
      <span className="ui-live-badge__dot" aria-hidden />
      {label}
    </span>
  );
}
